export function setCenterMap (state, value) {
  state.centerMap = value
}

export function setCurrentLatLng (state, latLng) {
  state.currentLatLng = latLng
}

export function setCurrentVideoIndex (state, index) {
  state.currentVideoIndex = index
}

export function setCurrentVideoTime (state, time) {
  state.currentVideoTime = time
}

export function setFetchingPlaylist (state, fetching) {
  state.fetchingPlaylist = fetching
}

export function setNoPlaylistFound (state, noPlaylistFound) {
  state.noPlaylistFound = noPlaylistFound
}

export function setPlaylist (state, playlist) {
  state.playlist = playlist
}

export function setStep (state, step) {
  state.step = step
}

export function resetState (state) {
  state.currentLatLng = null
  state.centerMap = false
  state.currentVideoIndex = 0
  state.currentVideoTime = 0
  state.fetchingPlaylist = false
  state.linestrings = []
  state.noPlaylistFound = false
  state.playlist = []
  state.step = 50
}
